export const GET_SESSION = "GET_SESSION";
export const SET_SUBSCRIBED = "SET_SUBSCRIBED";
export const SET_SIGNALRCONNECTED = "SET_SIGNALRCONNECTED";
export const SET_SESSION_HELPER = "SET_SESSION_HELPER";
